import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Teams = styled.div`
  display: flex;
  gap: 10px;
`;

export const TeamsSkeleton = () => {
  return (
    <Wrapper>
      <Teams>
        <Skeleton width={250} variant='rectangular' height={25} />
        <Skeleton width={250} variant='rectangular' height={25} />
      </Teams>
      <div>
        <Skeleton width={510} variant='rectangular' height={18} />
      </div>
    </Wrapper>
  );
};
